module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patients"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.edit_news")))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.$t("admin.editnews_note")))])]), _vm._v(" "), _c('md-card-content', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.newStatus($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.title")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.editor.title),
      callback: function($$v) {
        _vm.$set(_vm.editor, "title", $$v)
      },
      expression: "editor.title"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.content")))]), _vm._v(" "), _c('md-textarea', {
    attrs: {
      "maxlength": "1500"
    },
    model: {
      value: (_vm.editor.text),
      callback: function($$v) {
        _vm.$set(_vm.editor, "text", $$v)
      },
      expression: "editor.text"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.image")))]), _vm._v(" "), _c('md-file', {
    attrs: {
      "id": "fileInput"
    },
    model: {
      value: (_vm.editor.image),
      callback: function($$v) {
        _vm.$set(_vm.editor, "image", $$v)
      },
      expression: "editor.image"
    }
  })], 1), _vm._v(" "), _c('div', [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "md-value": "general"
    },
    model: {
      value: (_vm.editor.type),
      callback: function($$v) {
        _vm.$set(_vm.editor, "type", $$v)
      },
      expression: "editor.type"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.general")))]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "md-value": "consultingChange"
    },
    model: {
      value: (_vm.editor.type),
      callback: function($$v) {
        _vm.$set(_vm.editor, "type", $$v)
      },
      expression: "editor.type"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.change_appointment")))]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "md-value": "assistance"
    },
    model: {
      value: (_vm.editor.type),
      callback: function($$v) {
        _vm.$set(_vm.editor, "type", $$v)
      },
      expression: "editor.type"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.substitution")))])], 1), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    model: {
      value: (_vm.editor.published),
      callback: function($$v) {
        _vm.$set(_vm.editor, "published", $$v)
      },
      expression: "editor.published"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.release")))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.save")))])], 1)])], 1), _vm._v(" "), _c('section', {
    staticClass: "feed row"
  }, _vm._l((_vm.$store.state.feed), function(status) {
    return _c('div', {
      staticClass: "status col-md-4 col-xs-12"
    }, [_c('md-card', [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(status.title))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v(_vm._s(status.creator.name) + " - " + _vm._s(_vm._f("formatDate")(status.createdAt)))])]), _vm._v(" "), _c('md-card-content', [(status.image && status.image != 'null') ? _c('img', {
      attrs: {
        "src": status.image
      }
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(status.text) + "\n\t\t\t\t")])], 1)], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8e01cbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/FeedList.vue
// module id = 427
// module chunks = 2